.toggleButtonsContainer {
    margin-bottom: 10px;
}

.toggleButton {
    display: flex;
    align-items: center;
}